"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStatus = exports.StatusContextProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var _blox = require("../blox");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var StatusContext = /*#__PURE__*/_react["default"].createContext({});

var DISPLAY_TIME = 2000;

var StatusContextProvider = function StatusContextProvider(_ref) {
  var children = _ref.children;

  var bloxStatusRef = /*#__PURE__*/_react["default"].createRef();

  var value = {
    showStatus: function showStatus(options) {
      var _bloxStatusRef$curren;

      return (_bloxStatusRef$curren = bloxStatusRef.current) === null || _bloxStatusRef$curren === void 0 ? void 0 : _bloxStatusRef$curren.newStatus(options);
    },
    showSuccess: function showSuccess(message) {
      var _bloxStatusRef$curren2;

      return (_bloxStatusRef$curren2 = bloxStatusRef.current) === null || _bloxStatusRef$curren2 === void 0 ? void 0 : _bloxStatusRef$curren2.newStatus({
        variant: 'success',
        content: message,
        displayTime: DISPLAY_TIME
      });
    },
    showError: function showError(message) {
      var _bloxStatusRef$curren3;

      return (_bloxStatusRef$curren3 = bloxStatusRef.current) === null || _bloxStatusRef$curren3 === void 0 ? void 0 : _bloxStatusRef$curren3.newStatus({
        variant: 'error',
        content: message,
        displayTime: DISPLAY_TIME
      });
    }
  };
  return /*#__PURE__*/_react["default"].createElement(StatusContext.Provider, {
    value: value
  }, children, /*#__PURE__*/_react["default"].createElement(_blox.BloxStatus, {
    ref: bloxStatusRef,
    style: {
      '--z-index': 2000
    }
  }));
};

exports.StatusContextProvider = StatusContextProvider;

var useStatus = function useStatus() {
  return _react["default"].useContext(StatusContext);
};

exports.useStatus = useStatus;